export default {
  props: {
    provider: { type: Object },
    extendedCard: { type: Boolean },
    index: { type: String },
    blured: { type: Boolean },
    beforeSamplePlay: { type: Object },
    section: { type: String },
    keyword: { type: String },
    bookingQuote: { type: String },
    lastActiveText: { type: String },
    forceLinkDefault: { type: Boolean, detault: false }
  },

  methods: {
    onBook() {
      this.$emit('voiceover:book', this.provider);
    },

    onContact() {
      this.$emit('voiceover:contact', this.provider);
    }
  }
};